import { AppUserType } from "../../models/appUser";

export default function (appUser: AppUserType) {
  localStorage.setItem("appUser", JSON.stringify(appUser));
}
